import { useEffect, useMemo, useState } from 'react';
import { useGetUserCredentialsValidityAcQuery } from '../../../apiRtk/accessControlApi';
import { useCheckDormakabaAccessForUserMutation } from '../../../apiRtk/be4feApi';
import { IUser } from '../../../modules/user/store';

interface IUseDormakabaAccess {
  companyId: number;
  siteId: number;
  user: IUser;
  userId: number;
}

function useDormakabaAccess({ companyId, siteId, user, userId }: IUseDormakabaAccess) {
  const [hasDormakabaAccessForUser, setHasDormakabaAccessForUser] = useState<boolean | undefined>(undefined);

  const { data: userCredentialsValidityData } = useGetUserCredentialsValidityAcQuery({
    companyId: companyId.toString(),
    siteId: siteId.toString(),
    userId: userId.toString(),
  });
  const [checkDormakabaAccessForUser] = useCheckDormakabaAccessForUserMutation();

  useEffect(() => {
    checkDormakabaAccessForUser({ companyId, siteId, userId })
      .unwrap()
      .then(() => {
        setHasDormakabaAccessForUser(true);
      })
      .catch(() => {
        setHasDormakabaAccessForUser(false);
      });
  }, []);

  const computedEnrichedUser = useMemo(
    () => ({
      ...user,
      validFrom: userCredentialsValidityData?.validFrom,
      validTo: userCredentialsValidityData?.validTo,
    }),
    [user, userCredentialsValidityData]
  );

  return { enrichedUser: computedEnrichedUser, hasDormakabaAccessForUser };
}

export default useDormakabaAccess;
